import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgSelectModule } from '@ng-select/ng-select';

import { PipesModule } from './pipes.module';
import { MaterialModule } from './material.module';
import { DirectivesModule } from './directives.module';
import { FormsModule as FMCFormsModule } from '../modules/forms.module';
import { RequiredTagComponent } from '../components/simple/required-tag.component';
import { InlineViewLoaderComponent } from '../../shared/components/inline-view-loader/inline-view-loader.component';
import { ButtonIconLoaderComponent } from '../../shared/components/button-icon-loader/button-icon-loader.component';
import { NoRecordFoundComponent } from '../../shared/components/no-record-found/no-record-found.component';
import { DialogHeaderComponent } from '../components/dialog/dialog-header/dialog-header.component';
import { DialogButtonComponent } from '../components/dialog/dialog-button/dialog-button.component';
import { RefreshPaginationButtonComponent } from '../components/common/buttons/pagination/refresh-pagination.component';
import { DialogComponent } from '../components/dialog/dialog.component';
import { AlertComponent } from '../alert/alert.component';
import { PaginationLinksComponent } from '../components/pagination/pagination-links.component';
import { IconComponent } from '../components/icons/icon.component';
import { ValidationMessagesComponent } from '../components/validation-messages/validation-messages.component';
import { PrimaryButtonComponent } from '../components/common/buttons/primary-button.component';
import { DialogTitleComponent } from '../components/dialog/dialog-title.component';
import { ErrorsAlertComponent } from '../alert/errors-alert.component';
import { ContextMenuComponent } from '../components/context-menu/context-menu.component';
import { ShContextMenuModule } from 'ng2-right-click-menu';
import { PageSpinnerComponent } from '../components/page-spinner/page-spinner.component';
import { MatProgressSpinnerModule } from '@angular/material';
import { PageContentLayoutComponent } from '../layouts/page-content-layout.component';
import { TabComponent } from '../components/tab/tab.component';
import { InputErrorTextComponent, LinkTextComponent, TextComponent } from '../components/text/text.component';
import { BoxComponent } from '../components/common/box/box.component';
import { LayoutGridComponent } from '../components/common/grid/grid.component';
import { SortingIconComponent } from '../components/icons/sorting-icon.component';
import { AsyncContentComponent } from '../components/utils/async-content.component';
import { PageGoBackButtonComponent } from '../components/common/buttons/page/go-back-button.component';
import { DialogCloseButtonComponent } from '../components/dialog/buttons/dialog-close-button.component';
import { HorizontalPaginationComponent } from '../components/pagination/horizontal-pagination.component';
import { PrimaryDropdownButtonComponent } from '../components/common/buttons/primary-dropdown-button.component';
import { FieldViewComponent } from '../components/view/field/field-view.component';
import { TopPanelComponent } from '../components/widget/top-panel/top-panel.component';
import { CardComponent } from '../components/common/card/card.component';
import { SetPageAsHomeButtonComponent } from '../components/common/buttons/set-page-as-home.component';
import { IndentedContentComponent } from '../components/common/indented-list-content.component';
import { RouterModule } from '@angular/router';
import { ErrorComponent } from '../../error/error.component';
import { TableComponent } from '../components/table/table.component';
import { MapComponent, MapMarkerInfoWindowContentComponent } from '../components/map/map.component';
import { AgmCoreModule } from '@agm/core';
import { PillComponent } from '../components/common/pill.component';
import { AgmDirectionModule } from 'agm-direction';
import {
  FieldmagicDataGridCurrencyCellRenderer,
  FieldmagicDataGridNumericCellRenderer,
  FieldmagicDataGridActionsCellRenderer,
  FieldmagicDataGridPercentageCellRenderer,
  FieldmagicDataGridProgressivePercentageCellRenderer,
  FieldmagicDataGridCheckboxCellRenderer,
  FieldmagicDataGridDateTimeCellRenderer,
  FieldmagicDataGridTextCellRendererComponent,
  FieldmagicDataGridGroupCellRendererComponent,
} from '../components/data-grid/data-grid-cells-renderer.component';
import { AgGridModule } from 'ag-grid-angular';
import { FieldmagicDataGridComponent } from '../components/data-grid/data-grid.component';
import { FieldmagicDataGridSidebarMenuToolPanelComponent } from '../components/data-grid/data-grid-accessories.component';
import { FieldmagicLegendIndicatorsComponent } from '../components/information/legends-indicators/legend-indicators.component';
import { ConfigurationPageComponent } from '../admin-configure-pages/configuration-page.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FontAwesomeModule,
    MaterialModule,
    DirectivesModule,
    PipesModule,
    ShContextMenuModule,
    MatProgressSpinnerModule,
    RouterModule,
    AgmCoreModule,
    AgGridModule,
    AgmDirectionModule,
    AgGridModule,
  ],
  declarations: [
    InlineViewLoaderComponent,
    RequiredTagComponent,
    ButtonIconLoaderComponent,
    NoRecordFoundComponent,
    DialogHeaderComponent,
    DialogButtonComponent,
    RefreshPaginationButtonComponent,
    DialogComponent,
    AlertComponent,
    PaginationLinksComponent,
    IconComponent,
    ValidationMessagesComponent,
    PrimaryButtonComponent,
    DialogTitleComponent,
    ErrorsAlertComponent,
    ContextMenuComponent,
    PageSpinnerComponent,
    PageContentLayoutComponent,
    TabComponent,
    TextComponent,
    BoxComponent,
    LayoutGridComponent,
    SortingIconComponent,
    AsyncContentComponent,
    PageGoBackButtonComponent,
    InputErrorTextComponent,
    DialogCloseButtonComponent,
    HorizontalPaginationComponent,
    PrimaryDropdownButtonComponent,
    FieldViewComponent,
    TopPanelComponent,
    CardComponent,
    SetPageAsHomeButtonComponent,
    IndentedContentComponent,
    LinkTextComponent,
    ErrorComponent,
    TableComponent,
    MapComponent,
    MapMarkerInfoWindowContentComponent,
    PillComponent,
    FieldmagicDataGridCurrencyCellRenderer,
    FieldmagicDataGridNumericCellRenderer,
    FieldmagicDataGridActionsCellRenderer,
    FieldmagicDataGridPercentageCellRenderer,
    FieldmagicDataGridProgressivePercentageCellRenderer,
    FieldmagicDataGridComponent,
    FieldmagicDataGridCheckboxCellRenderer,
    FieldmagicDataGridDateTimeCellRenderer,
    FieldmagicDataGridTextCellRendererComponent,
    FieldmagicDataGridGroupCellRendererComponent,
    FieldmagicDataGridSidebarMenuToolPanelComponent,
    FieldmagicLegendIndicatorsComponent,
    ConfigurationPageComponent,
  ],
  entryComponents: [
    FieldmagicDataGridCurrencyCellRenderer,
    FieldmagicDataGridNumericCellRenderer,
    FieldmagicDataGridActionsCellRenderer,
    FieldmagicDataGridPercentageCellRenderer,
    FieldmagicDataGridProgressivePercentageCellRenderer,
    FieldmagicDataGridCheckboxCellRenderer,
    FieldmagicDataGridDateTimeCellRenderer,
    FieldmagicDataGridTextCellRendererComponent,
    FieldmagicDataGridGroupCellRendererComponent,
    FieldmagicDataGridSidebarMenuToolPanelComponent,
    FieldmagicLegendIndicatorsComponent,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    FontAwesomeModule,
    MaterialModule,
    NgSelectModule,
    PipesModule,
    InlineViewLoaderComponent,
    RequiredTagComponent,
    DirectivesModule,
    FMCFormsModule,
    ButtonIconLoaderComponent,
    NoRecordFoundComponent,
    RefreshPaginationButtonComponent,
    DialogHeaderComponent,
    DialogButtonComponent,
    DialogComponent,
    AlertComponent,
    PaginationLinksComponent,
    IconComponent,
    ValidationMessagesComponent,
    PrimaryButtonComponent,
    DialogTitleComponent,
    ErrorsAlertComponent,
    ContextMenuComponent,
    PageContentLayoutComponent,
    TabComponent,
    TextComponent,
    BoxComponent,
    LayoutGridComponent,
    SortingIconComponent,
    AsyncContentComponent,
    PageGoBackButtonComponent,
    InputErrorTextComponent,
    DialogCloseButtonComponent,
    HorizontalPaginationComponent,
    PrimaryDropdownButtonComponent,
    FieldViewComponent,
    TopPanelComponent,
    CardComponent,
    SetPageAsHomeButtonComponent,
    IndentedContentComponent,
    LinkTextComponent,
    ErrorComponent,
    TableComponent,
    MapComponent,
    PillComponent,
    FieldmagicDataGridCurrencyCellRenderer,
    FieldmagicDataGridNumericCellRenderer,
    FieldmagicDataGridActionsCellRenderer,
    FieldmagicDataGridPercentageCellRenderer,
    FieldmagicDataGridProgressivePercentageCellRenderer,
    FieldmagicDataGridComponent,
    FieldmagicDataGridCheckboxCellRenderer,
    FieldmagicDataGridDateTimeCellRenderer,
    FieldmagicDataGridTextCellRendererComponent,
    FieldmagicDataGridGroupCellRendererComponent,
    FieldmagicDataGridSidebarMenuToolPanelComponent,
    FieldmagicLegendIndicatorsComponent,
    ConfigurationPageComponent
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [] // TranslateService
    };
  }

  static forChild(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
    };
  }
}
